module.exports = __webpack_public_path__ + "static/media/public-insurance.eab6190b.png";